// extracted by mini-css-extract-plugin
module.exports = {"NavItem":"NavItem_NavItem__33Id1","active":"NavItem_active__2FIiU"};